













import Vue from "vue";
import iwInputAutoComplete from "../../buildingBlocks/InputAutoComplete.vue";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

// import mbxClient from "@mapbox/mapbox-sdk";
import mbxGeocoding, { GeocodeRequest } from "@mapbox/mapbox-sdk/services/geocoding";

// Interfaces
import { InputAutoCompleteSuggestions } from "@/shared/interfaces/InputAutoComplete.interface";
import { GeocodeFeature } from "@/shared/interfaces/mapbox/Geocoding.interface";
import { mapGetters } from "vuex";

export default Vue.extend({
    components: {
        iwInputAutoComplete: iwInputAutoComplete
    },
    props: {
        addressDetailsIsDisplay: {
            type: Boolean,
            required: false,
            default: false
        },
        completeAddress: {
            type: String,
            required: false,
            default: ""
        }
    },
    data: function() {
        return {
            suggestions: [] as Array<InputAutoCompleteSuggestions>,
            automaticPrefillAddress: true
        };
    },
    computed: {
        ...mapGetters({
            shouldDisplayError: "StepsWizard/shouldDisplayError",
            getFirstPublicationDate: "FormModule/getFirstPublicationDate",
            editNotAllowed: "FormModule/editNotAllowed",
        }),
        errorMessage: function(): string {
            if (!this.addressDetailsIsDisplay) {
                if (this.shouldDisplayError && (this.$store.getters["FormModule/getErrorObjectByPath"]("property.location.address.street") ||
                    this.$store.getters["FormModule/getErrorObjectByPath"]("property.location.address.locality") ||
                    this.$store.getters["FormModule/getErrorObjectByPath"]("property.location.address.number") ||
                    this.$store.getters["FormModule/getErrorObjectByPath"]("property.location.address.postalCode") ||
                    this.$store.getters["FormModule/getErrorObjectByPath"]("property.location.address.country"))) {
                    return this.$t("please_enter_an_address") as string;
                }
            }

            return "";
        },
        hasAlreadyCoordinates: function(): number {
            return this.$store.getters["FormModule/getValueUI"]("urlMapbox.coordinates");
        },
    },
    mounted: function() {
        if(this.addressDetailsIsDisplay && !this.hasAlreadyCoordinates) {
            this.fetchSuggestions(this.completeAddress);
        }
    },
    methods: {
        fetchSuggestions: function(value: string) {
            const mapBoxApiToken = process.env.VUE_APP_IMMOWEB_MAPBOX_API_TOKEN;

            if (mapBoxApiToken) {
                const geocodingClient = mbxGeocoding({
                    accessToken: mapBoxApiToken
                });

                const optionsGeoCode: GeocodeRequest = {
                    mode: "mapbox.places",
                    query: value,
                    limit: 5,
                    proximity: [4.6644863, 50.6401734],
                    types: ["address"],
                    language: [Trans.currentLocale]
                };

                if(value.length < 2) {
                    optionsGeoCode.countries = ["be"];
                }

                geocodingClient.forwardGeocode(optionsGeoCode)
                    .send()
                    .then((response) => {

                        const predictions = response.body.features;

                        if (predictions) {
                            predictions.forEach((prediction: GeocodeFeature, index: number) => {

                                let suggestionLabel = prediction.text;
                                const placeContext = prediction.context as Array<GeocodeFeature>;

                                let locality = "";
                                let country = "";

                                if (placeContext) {
                                    placeContext.forEach((entry) => {

                                        if (entry.id.indexOf("place") != -1) {
                                            locality = entry.text;
                                        }

                                        if (entry.id.indexOf("country") != -1) {
                                            country = entry.text;
                                        }
                                    });
                                }

                                if (prediction.address) {
                                    suggestionLabel += " " + prediction.address;
                                }

                                if (locality) {
                                    suggestionLabel += ", " + locality;
                                }

                                if (country) {
                                    suggestionLabel += ", " + country;
                                }

                                const suggestion = {
                                    "label": suggestionLabel,
                                    "id": prediction.id,
                                    "originalObject": prediction
                                };

                                if (this.suggestions.length < 5) {
                                    this.suggestions.push(suggestion);
                                } else {
                                    Vue.set(this.suggestions, index, suggestion);
                                }
                            });
                            if(this.suggestions && !this.hasAlreadyCoordinates && this.automaticPrefillAddress && this.completeAddress) {
                                const street = this.completeAddress.split(",")[0];
                                const findStreetInSuggestion = this.suggestions.findIndex(suggestion => {
                                    return suggestion.label.includes(street);
                                });
                                if(findStreetInSuggestion !== -1) {
                                    this.autofillAddress(this.suggestions[findStreetInSuggestion]);
                                    this.suggestions = [];
                                }
                                this.automaticPrefillAddress = false;
                            }
                        }
                    });

            }
        },
        autofillAddress: function (selectedValue: InputAutoCompleteSuggestions) {
            const originalObject = selectedValue.originalObject;

            if (originalObject) {

                const placeContext = originalObject.context;

                const geometry = originalObject.geometry;
                if (geometry) {
                    this.$emit("display-map", {
                        lat: geometry.coordinates[1],
                        lng: geometry.coordinates[0],
                    });
                }

                if(placeContext) {
                    placeContext.forEach((entry) => {

                        if(!this.getFirstPublicationDate) {
                            if (entry.id.indexOf("postcode") != -1) {

                                const postalCode = entry.text;

                                this.$store.dispatch("FormModule/addValue", {path: "property.location.address.postalCode", value: postalCode});
                            }

                            if (entry.id.indexOf("place") != -1) {

                                const locality = entry.text;

                                this.$store.dispatch("FormModule/addValue", {path: "property.location.address.locality", value: locality});
                            }
                        }

                        if (entry.id.indexOf("country") != -1) {
                            const country = entry.short_code.toUpperCase();

                            this.$store.dispatch("FormModule/addValue", {path: "property.location.address.country", value: country});
                        }
                    });
                }

                const number = originalObject.address;
                if (number) {
                    this.$store.dispatch("FormModule/addValue", {path: "property.location.address.number", value: number});
                }

                const placeType = originalObject.place_type as Array<string>;

                if (placeType) {
                    placeType.forEach((entry) => {
                        if (entry === "address" || entry === "poi") {
                            const street = originalObject.text;

                            this.$store.dispatch("FormModule/addValue", {path: "property.location.address.street", value: street});
                        }
                    });
                }

                this.$emit("display-address-detail");
            }
        },
    }
});
